import { isEmpty } from 'lodash';

import {
    REQUEST_FORM_SUBMIT_PAYMENT,
    SUCCESS_FORM_SUBMIT_PAYMENT,
    FAILURE_FORM_SUBMIT_PAYMENT,
    REQUEST_EBON_FORM_SUBMIT_PAYMENT,
    SUCCESS_EBON_FORM_SUBMIT_PAYMENT,
    FAILURE_EBON_FORM_SUBMIT_PAYMENT
} from './constants';
import { CALL_API } from '../../../../middlewares/api';

import { fetchPaymentRequestOnGoingIfNeeded } from '../ongoing/actions';

export const ERROR_FORMDATA_EMPTY =
    '[sendPaymentRequest]formData param must not be empty or null or undefined !';

/**
 * Send payment request form to server
 * headers = {} to put empty headers in request
 * @param {FormData} formData
 */
export function sendPaymentRequest(formData, callback) {
    if (isEmpty(formData)) {
        throw new Error(ERROR_FORMDATA_EMPTY);
    }
    return {
        [CALL_API]: {
            endpoint: '/payment',
            types: [
                REQUEST_FORM_SUBMIT_PAYMENT,
                SUCCESS_FORM_SUBMIT_PAYMENT,
                FAILURE_FORM_SUBMIT_PAYMENT
            ],
            body: formData,
            successCallback: (response, dispatch) => {
                dispatch(fetchPaymentRequestOnGoingIfNeeded());
                if (callback) {
                    callback();
                }
            }
        }
    };
}
export function sendPaymentEbonRequest(formData, callback) {
    if (isEmpty(formData)) {
        throw new Error(ERROR_FORMDATA_EMPTY);
    }
    return {
        [CALL_API]: {
            endpoint: '/payment/ebon',
            types: [
                REQUEST_EBON_FORM_SUBMIT_PAYMENT,
                SUCCESS_EBON_FORM_SUBMIT_PAYMENT,
                FAILURE_EBON_FORM_SUBMIT_PAYMENT
            ],
            body: formData,
            successCallback: (response, dispatch) => {
                dispatch(fetchPaymentRequestOnGoingIfNeeded());
                if (callback) {
                    callback();
                }
            }
        }
    };
}



// WEBPACK FOOTER //
// ./src/services/account/paymentrequest/request/actions.js